import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgFolderAdd(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 14a1 1 0 0 1 1 1v2h2l.102.005a1 1 0 0 1 0 1.99L21 19h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1ZM10 3a3 3 0 0 1 3 3v1h6a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1H4v9l.005.102A1 1 0 0 0 5 19h6a1 1 0 1 1 0 2H5a3 3 0 0 1-2.996-2.846L2 18V6a3 3 0 0 1 3-3h5ZM5 5a1 1 0 0 0-1 1v1h7V6a1 1 0 0 0-1-1H5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgFolderAdd)
